import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/MapPin.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: n }));
a.displayName = "MapPinIcon";
const p = a;
export {
  p as MapPin,
  a as MapPinIcon
};
